module.exports = __webpack_public_path__ + "img/analysisBgImg.b709099e.png";